import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Profile from './components/Profile';
import PublicProfile from './components/PublicProfile';
import { Box, CircularProgress } from '@mui/material';

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return isAuthenticated ? <Profile /> : <Login />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/public/:koalmNumber"
          element={<PublicProfile />}
        />
        <Route
          path="/*"
          element={
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;

